import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_STAFF_LIST:
            return updateObject(state, { staffList: action.state })
        default:
            return state;
    }
}

export default reducer